import React from "react"; // Update the path based on your project structure
import Textarea from "../textarea";

const CustomTextArea = ({
	label,
	name,
	placeholder,
	value,
	onChange,
	maxLength,
	validation,
	error,
	disabled = false,
	className = "",
}) => (
	<>
		<div className="flex items-center col-span-1">
			<p className="my-auto">{label}</p>
		</div>
		<div className="col-span-4">
			<Textarea
				placeholder={placeholder}
				classNameParent="w-full"
				classNameInside={className}
				name={name}
				onChange={onChange}
				value={value}
				maxLength={maxLength}
				validation={validation}
				error={error}
				autocomplete="off"
				disabled={disabled}
			/>
		</div>
	</>
);

export default CustomTextArea;
